import { useCallback, useEffect, useRef, useState } from "react";
import { ExpertiseListModel } from "./models/ExpertiseListModel";
import { getExpertiseAdminList } from "../../services/partnerExpertService";

export const useExpertiseAdminTable = (page: number, status: "new"|"rejected"|"active", search?: string) => {
    const limit = 10;
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<ExpertiseListModel[]>([]);
    const [filters, setFilters] = useState<{limit: number, offset: number, status: "new"|"rejected"|"active"}>({ limit, offset: 0, status });
    const [totalPages, setTotalPages] = useState(1);
    
    useEffect(() => {
        const offset = (page - 1) * limit;
        setFilters({ limit, offset, status });
    }, [page, status]);
    
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            setList([]);
            const _result = await getExpertiseAdminList(filters.status, filters.limit, filters.offset, search)
            if(!isMountedRef.current)
                return;
            setList(_result.results);
            const _totalPages = Math.ceil(_result.count / limit);
            setTotalPages(_totalPages);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [filters, search]);

    useEffect(() => {
        load();
    }, [load]);

    // PR-I-87 — reload() se expone para refrescar tabla tras approve/decline en el drawer sin
    // depender de re-render por cambio de filtros.
    return { loading, list, totalPages, reload: load }
}